import { useEffect, useRef, useState } from "react"
import styled from "styled-components"

import UnderConstructionImage from "#assets/underConstruction.png"

const LINES = [
  "Corgis at work! New tricks coming soon 🐾",
  "Building something paw-some… Check back later!",
  "Our corgi crew is still fetching the final touches!",
  "Please pardon the mess. We're still working on this!",
]

const getRandomLine = () => {
  return LINES[Math.floor(Math.random() * LINES.length)]
}

const SWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1000;
`

const SContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.1;
  transition: opacity 0.2s ease-in-out;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  &:hover {
    opacity: 1;
  }
`

const SImage = styled.img<{ containerWidth: number; containerHeight: number }>`
  max-width: min(60%, ${(props) => props.containerWidth * 0.8}px);
  max-height: min(60%, ${(props) => props.containerHeight * 0.8}px);
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.2));
`

const SText = styled.div`
  font-size: 20px;
  color: #666;
  text-align: center;
  max-width: 250px;
  opacity: 0;
  transform: translateY(5px) scale(0.9);
  transition: all 0.3s ease-in-out;
  padding: 12px 16px;
  border-radius: 8px;
  background: radial-gradient(
    ellipse at center,
    rgba(255, 255, 255, 0.9) 0%,
    rgba(255, 255, 255, 0.4) 70%,
    transparent 100%
  );
  text-shadow: 0 1px 3px rgba(255, 255, 255, 0.8);

  ${SContainer}:hover & {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`

const UnderConstruction = () => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const [randomLine, setRandomLine] = useState("")
  const [containerSize, setContainerSize] = useState({
    width: 200,
    height: 200,
  })

  useEffect(() => {
    setRandomLine(getRandomLine())
  }, [])

  useEffect(() => {
    const wrapper = wrapperRef.current
    if (!wrapper) return

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (entry) {
        setContainerSize({
          width: entry.contentRect.width,
          height: entry.contentRect.height,
        })
      }
    })

    resizeObserver.observe(wrapper)
    return () => resizeObserver.disconnect()
  }, [])

  return (
    <SWrapper ref={wrapperRef}>
      <SContainer>
        <SImage
          src={UnderConstructionImage}
          alt="Under Construction"
          containerWidth={containerSize.width}
          containerHeight={containerSize.height}
        />
        <SText>{randomLine}</SText>
      </SContainer>
    </SWrapper>
  )
}

export default UnderConstruction
